import type { RouteRecordRaw } from 'vue-router';
import { GIFTCARD_ROUTE_NAME } from '@/consts';

export const giftCardRoutes: RouteRecordRaw = {
  path: '/gift-card',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true },
  children: [
    {
      name: GIFTCARD_ROUTE_NAME.GIFTCARD,
      path: '',
      component: () => import('./GiftCard.vue'),
    },
  ],
};
